module.exports = __webpack_public_path__ + "static/media/allcity-logo.883bfd4b.png";